import frFlag from '../assets/icones/fr-flag.png';
import ukFlag from '../assets/icones/uk-flag.png';
import plFlag from '../assets/icones/pl-flag.png';
import esFlag from '../assets/icones/es-flag.png';
import itFlag from '../assets/icones/it-flag.svg';
import deFlag from '../assets/icones/ge-flag.svg';
import ptFlag from '../assets/icones/po.jpg';
import csFlag from '../assets/icones/rp-flag.png';
import nlFlag from '../assets/icones/pb-flag.png';

export const LANGS = [
  { code: 'pl', flag: plFlag, alt: 'Polski' },
  { code: 'fr', flag: frFlag, alt: 'Français' },
  { code: 'en', flag: ukFlag, alt: 'English' },
  { code: 'es', flag: esFlag, alt: 'Español' },
  { code: 'it', flag: itFlag, alt: 'Italiano' },
  { code: 'de', flag: deFlag, alt: 'Deutsch' },
  { code: 'pt', flag: ptFlag, alt: 'Português' },
  { code: 'cs', flag: csFlag, alt: 'Čeština' },
  { code: 'nl', flag: nlFlag, alt: 'Nederlands' },
];
